import React from 'react';
import { PiWarningDiamondFill } from "react-icons/pi";

export default function Error({status}) {
  return (
    <>
       <div className=" card-center text-center">
    {/* <h1 className="mb-4 text-6xl font-semibold text-[#726d6d]">404</h1> */}
    <p className="mb-4 text-lg text-gray-600">Oops! No data found.</p>
    <div className="animate-bounce">
    <PiWarningDiamondFill className=' w-[100%] h-20' />
    </div>
    <p className="mt-4 text-gray-600">Let's get you back <a href="/" className="text-blue-500">home</a>.</p>
  </div>
    </>
  )
}
